import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import {
  reducer as accountingReducer,
  saga as accountingSaga,
} from './accounting/index';
import {
  reducer as companyReducer,
  saga as companySaga,
} from './company/index';
import {
  reducer as digitalQuoteReducer,
  saga as digitalQuoteSaga,
} from './digitalQuote/index';
import {
  reducer as integrationsReducer,
  saga as integrationsSaga,
} from './integrations/index';
import {
  reducer as smartRfqReducer,
  saga as smartRfqSaga,
} from './quoteCreation/index';
import routes from './routes';
import {
  reducer as userProfileReducer,
  saga as userProfileSaga,
} from './userProfile/index';

const reducer = combineReducers({
  accounting: accountingReducer,
  company: companyReducer,
  digitalQuote: digitalQuoteReducer,
  integrations: integrationsReducer,
  userProfile: userProfileReducer,
  smartRfq: smartRfqReducer,
});

const saga = function* () {
  yield all([
    accountingSaga(),
    companySaga(),
    digitalQuoteSaga(),
    integrationsSaga(),
    smartRfqSaga(),
    userProfileSaga(),
  ]);
};

export { reducer, routes, saga };
